import React from 'react';
import moment from 'moment-timezone';

import { Box, Typography } from '@mui/material';

import { LocaleField } from 'common/types';
import { useTranslation } from 'services/localization/useTranslation';
import useShopFormat from 'hooks/useShopFormat';
import DeliveryHeader from './DeliveryHeader';

interface Props {
	date: string;
	handlingTimeMinutesAfter: number;
	returnInstructions?: LocaleField;
}

const SelfReturnDetails = (props: Props) => {
	const { date, handlingTimeMinutesAfter, returnInstructions } = props;
	const { t, getTranslation } = useTranslation();
	const { localFormat } = useShopFormat();

	const endDate = moment(date);
	const endDateWithHandlingTime = endDate.clone().add(handlingTimeMinutesAfter, 'minutes');

	const renderDateRange = (date1: moment.Moment, date2: moment.Moment) =>
		`${localFormat(date1, 'ddd. MMM D, HH:mm')} - ${localFormat(date2, 'ddd. MMM D, HH:mm')}`;

	return (
		<Box>
			<DeliveryHeader
				type="self-return"
				dateString={
					handlingTimeMinutesAfter === 0
						? localFormat(endDate, 'ddd. MMM D, HH:mm')
						: renderDateRange(endDate, endDateWithHandlingTime)
				}
			/>
			<Box mt={2} />
			<Typography variant="body2">
				{t('delivery.customerSelfReturnInstructions', 'Return instructions given to customer:')}
			</Typography>
			<Typography variant="caption" sx={{ fontStyle: 'italic' }}>
				{!!returnInstructions
					? getTranslation(returnInstructions)
					: t('delivery.defaultReturnInstructions', 'The order is returned by the customer')}
			</Typography>
		</Box>
	);
};

export default SelfReturnDetails;
